import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import WhyChoose from "@/components/WhyChoose";
import Enterprise from "@/components/Enterprise";
import { HERO_IMAGES } from "@/data/heroImages";

export default function PourquoiNousPage() {
  const navigate = useNavigate();
  return (
    <>
      <PageHero
        eyebrow="Pourquoi nous choisir"
        title="Une école qui change les"
        italicWord="règles"
        subtitle="Ici, on n'apprend pas passivement. On imagine, on teste, on échoue, on recommence. Du pitch initial à la mise en œuvre finale, chaque projet, de l'idée à la réalisation, construit pas à pas votre agilité sur le terrain. C'est ainsi que naissent les profils qui ne se contentent pas de suivre les règles… ils les réinventent."
        crumb="Pourquoi nous"
        image={HERO_IMAGES.pourquoiNous}
        cta={
          <button onClick={() => navigate("/contact#candidater")} className="btn-red">
            Candidater
            <ArrowRight className="h-4 w-4" />
          </button>
        }
      />
      <WhyChoose />
      <Enterprise />
    </>
  );
}
